// Web port of app/src/contexts/DiagnosticsJsonApiContext.js.
//
// The diagnostics REST client (darwin_core/api/diagnosticsJsonapi) is itself
// RN-free: it authenticates via aws-amplify/auth fetchAuthSession and its only
// non-web import (components/Logger) is redirected to a web shim by the
// darwinCoreShims Vite plugin. The mobile provider passes Amplify's v5 `Auth`
// into the factory, but that factory IGNORES its argument (it calls
// fetchAuthSession directly), so this port drops the dead v5 import and calls it
// with no argument. It is NOT reachable through the darwin_core barrel, so it is
// imported by its subpath alias.
import { createContext, useContext, useEffect, useState } from 'react';

import diagnosticsJsonApiSetup from 'darwin_core/api/diagnosticsJsonapi';

export const DiagnosticsJsonApiContext = createContext({ diagsApi: undefined });

export function DiagnosticsJsonApiProvider({ children }) {
  const [diagsApi, setDiagsApi] = useState();

  useEffect(() => {
    setDiagsApi(diagnosticsJsonApiSetup());
  }, []);

  return (
    <DiagnosticsJsonApiContext.Provider value={{ diagsApi }}>
      {children}
    </DiagnosticsJsonApiContext.Provider>
  );
}

// Consumer hook. Returns `{ diagsApi }`; diagsApi is undefined until the mount
// effect has run. The store bootstrap tolerates a missing diagsApi — the hello
// refresh's partner-access fetch simply no-ops (its own try/catch swallows it).
export function useDiagnosticsJsonApi() {
  return useContext(DiagnosticsJsonApiContext);
}
